import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../lib/auth.jsx";
import { useT } from "../lib/i18n.jsx";
import { IconArrow } from "../components/icons.jsx";

export default function LoginPage() {
  const { login } = useAuth();
  const { t, toggleLang } = useT();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/devices";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  async function submit(e) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try { await login(email, password); navigate(from, { replace: true }); }
    catch (err) { setError(err.message); }
    finally { setBusy(false); }
  }

  return (
    <div className="auth">
      <aside className="auth-aside">
        <div className="auth-aside-top">
          <div className="auth-brand">vorks<span className="con">·connect</span></div>
          <div className="eyebrow" style={{ marginTop: 18 }}>Control Plane</div>
          <motion.h1 className="auth-headline" initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            Remote desktops, <em>orchestrated</em>.
          </motion.h1>
          <motion.p className="auth-sub" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.15 }}>
            Manage every host on your network from one place. Encrypted connections, granular access, audit-grade logging.
          </motion.p>
        </div>
        <div className="auth-footer auth-aside-bottom">
          <span>v0.1 · phase 1</span>
          <button onClick={toggleLang} style={{ background: "none", border: "none", color: "var(--text-faint)", fontFamily: "var(--mono)", fontSize: 10.5, cursor: "pointer", letterSpacing: "0.15em", textTransform: "uppercase" }}>
            {t("lang_switch")}
          </button>
        </div>
      </aside>
      <main className="auth-main">
        <motion.div className="auth-card" initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}>
          <div className="eyebrow">{t("auth_sign_in")}</div>
          <h1>{t("auth_welcome_back")}</h1>
          <p className="sub">Enter your credentials to access the control plane.</p>
          <form onSubmit={submit}>
            <div className="field"><label>{t("auth_email")}</label>
              <input type="email" required autoFocus autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} disabled={busy} />
            </div>
            <div className="field"><label>{t("auth_password")}</label>
              <input type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} disabled={busy} />
            </div>
            <button className="btn primary full lg" type="submit" disabled={busy}>
              {busy ? t("auth_authenticating") : t("auth_sign_in")} <IconArrow size={14} />
            </button>
            {error && <div className="error-line">{error}</div>}
          </form>
        </motion.div>
      </main>
    </div>
  );
}
